import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "fluidPayPrivateApiKey",
    "fluidPayPublicApiKey",
    "fluidPayUrl",
    "gatewayExampleArguments",
    "gatewayNotes",
    "gatewaySelect",
    "merchantIdError",
    "merchantIdErrorMessage",
    "merchantIdField",
    "merchantIdSuccess",
  ]
  static values = { fetchMerchantIdUrl: String }

  // Asks the server to look up the merchant id from FluidPay using the API key
  // fields as currently filled in (unsaved edits included). The fetched value
  // only fills the readonly field; it is persisted when the form is saved.
  async fetchMerchantId() {
    this.merchantIdSuccessTarget.hidden = true
    this.merchantIdErrorTarget.hidden = true

    if (!this.fluidPayPrivateApiKeyTarget.value.trim()) {
      this.showMerchantIdError("Fill in the Fluid Pay API key fields first.")
      return
    }

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const body = new FormData()
    body.append("fluid_pay_private_api_key", this.fluidPayPrivateApiKeyTarget.value)
    body.append("fluid_pay_public_api_key", this.fluidPayPublicApiKeyTarget.value)
    body.append("fluid_pay_url", this.fluidPayUrlTarget.value)

    try {
      const response = await fetch(this.fetchMerchantIdUrlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": token, Accept: "application/json" },
        body,
      })
      const data = await response.json()

      if (response.ok) {
        this.merchantIdFieldTarget.value = data.merchant_id
        this.merchantIdSuccessTarget.hidden = false
      } else {
        this.showMerchantIdError(data.error || "FluidPay request failed.")
      }
    } catch {
      this.showMerchantIdError("Could not reach the server.")
    }
  }

  gatewayChange() {
    const gateways = JSON.parse(this.gatewaySelectTarget.dataset.gateways)
    const selectedGateway = gateways[this.gatewaySelectTarget.value] || { notes: "", example_args: "" }
    this.gatewayNotesTarget.value = selectedGateway.notes
    this.gatewayExampleArgumentsTarget.value = selectedGateway.example_args
  }

  showMerchantIdError(message) {
    this.merchantIdErrorMessageTarget.textContent = message
    this.merchantIdErrorTarget.hidden = false
  }
}
